import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import articlesIt from '../articlesIt'; // Імпортуй перекладені статті італійською
import styles from './BlogArticlePageIt.module.css';

const BlogArticlePageIt = () => {
  const { id, title } = useParams();
  const article = articlesIt.find(a => a._id === id);

  if (!article) {
    return (
      <>
        <Helmet>
          <title>404 – Articolo non trovato | Artemida Studio</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className={styles.errorContainer}>
          <h1>404 – Articolo non trovato</h1>
          <p>Non siamo riusciti a trovare l’articolo che stai cercando.</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{article.title} | Blog di Artemida Studio</title>
        <meta name="description" content={article.description} />
        <meta name="keywords" content={article.keywords} />
        <link
          rel="canonical"
          href={`https://artemidastudio.com/it/blog/article/${title}/${id}`}
        />
        <link
          rel="alternate"
          hreflang="it"
          href={`https://artemidastudio.com/it/blog/article/${title}/${id}`}
        />
        <link
          rel="alternate"
          hreflang="en"
          href={`https://artemidastudio.com/en/blog/article/${title}/${id}`}
        />
        <link
          rel="alternate"
          hreflang="de"
          href={`https://artemidastudio.com/de/blog/article/${title}/${id}`}
        />
        <link
          rel="alternate"
          hreflang="x-default"
          href={`https://artemidastudio.com/en/blog/article/${title}/${id}`}
        />
      </Helmet>

      <div className={styles.articleContainer}>
        <h1 className={styles.title}>{article.title}</h1>

        <div className={styles.imgContainer}>
          <img src={article.image} alt={article.title} loading="lazy" />
        </div>

        <div
          className={styles.content}
          style={{ whiteSpace: 'pre-wrap' }}
          dangerouslySetInnerHTML={{ __html: article.content }}
        />
      </div>
    </>
  );
};

export default BlogArticlePageIt;
